import { createContext, useContext } from 'react';

export const ScoreSheetContext = createContext(null);

export const useScoreSheetContext = () => {
  const context = useContext(ScoreSheetContext);
  if (!context) {
    throw new Error(
      'useScoreSheetContext must be used within a ScoreSheetContext Provider'
    );
  }
  return context;
};
